import { SocialMediaComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import EmptyComponent from '../../../pageBuilder/EmptyComponent';
import { FaSquareXTwitter, FaFacebook, FaInstagram, FaLinkedin, FaTiktok, FaYoutube, FaGlobe } from 'react-icons/fa6';
import React from 'react';
import Link from 'next/link';

interface SocialButtonProps {
  type: string;
  url: string;
  iconBackgroundColor?: string;
  iconSize?: number;
  borderRadius?: number;
}

const SocialButton = ({ type, url, iconBackgroundColor, iconSize, borderRadius }: SocialButtonProps) => {
  const socialIcon = () => {
    switch (type) {
      case 'instagram':
        return <FaInstagram />;
      case 'facebook':
        return <FaFacebook />;
      case 'xtwitter':
        return <FaSquareXTwitter />;
      case 'linkedin':
        return <FaLinkedin />;
      case 'tiktok':
        return <FaTiktok />;
      case 'youtube':
        return <FaYoutube />;
      case 'website':
      default:
        return <FaGlobe />;
    }
  };

  return (
    <Link href={url} target="_blank">
      <span
        className="flex justify-center items-center p-3 transition-all hover:scale-110"
        style={{
          backgroundColor: iconBackgroundColor,
          borderRadius: `${borderRadius ?? 0}%`,
        }}>
        {React.cloneElement(socialIcon(), {
          style: { width: `${(iconSize ?? 0) * 4 + 20}px`, height: 'auto' },
        })}
      </span>
    </Link>
  );
};

const SocialMediaComponent = ({ uiComponent }: UiComponentElementInterface<SocialMediaComponentInterface>) => {
  return (
    <div
      className="w-full text-slate-800"
      style={{
        color: uiComponent?.styling?.textColor,
      }}>
      {uiComponent?.socialMedias && uiComponent.socialMedias.length > 0 ? (
        <div className="flex flex-row flex-wrap gap-4 justify-center items-center w-full">
          {uiComponent.socialMedias.map((social) => {
            return (
              <SocialButton
                key={'social-media-' + social}
                type={social}
                url={uiComponent?.socialMediaLinks?.[social] ?? '#'}
                iconBackgroundColor={uiComponent.customStyling.socialMedia?.iconBackgroundColor}
                iconSize={uiComponent.customStyling.socialMedia?.iconSize}
                borderRadius={uiComponent.customStyling.socialMedia?.borderRadius}
              />
            );
          })}
        </div>
      ) : (
        <EmptyComponent componentName="Social Media Component" />
      )}
    </div>
  );
};

export default SocialMediaComponent;
